import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface OccupationsState {
  occupations: any
  occupation: any
  error: any
}

export const useOccupationsStore = defineStore('occupations', {
  state: (): OccupationsState => ({
    occupations: null,
    occupation: null,
    error: null,
  }),

  getters: {
    getOccupations: (state) => state.occupations,
    getOccupation: (state) => state.occupation,
    getError: (state) => state.error,
  },

  actions: {
    async fetchOccupations() {
      try {
        const response = await api().get('configuration/occupation/all')
        this.occupations = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async createOccupation(data: any) {
      try {
        const response = await api().post('configuration/occupation/create', data)
        this.occupation = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },
  },
})
